import { useEffect } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import {
  FETCH_MANAGE_STAFF_PAGE,
  FetchManageStaffPageQuery,
  FetchManageStaffPageQueryVariables,
  ManageUsersPage,
} from '@edwin-group/cj-graphql';
import { useManageStaffStore } from '../store/useManageStaffStore';

export const useRoot = () => {
  const { data, error } = useSuspenseQuery<FetchManageStaffPageQuery, FetchManageStaffPageQueryVariables>(
    FETCH_MANAGE_STAFF_PAGE,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    useManageStaffStore.setState({ page: data?.manageUsersPage as ManageUsersPage });
  }, [data]);

  return { page: data?.manageUsersPage ?? null, error };
};
